// extracted by css-extract-rspack-plugin
export default {"root":"EntityPickerActionButton_root__vLPtC"};